/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// Pobierz wszystkie linki i sekcj
const links = document.querySelectorAll('.tab-btn');
const sections = document.querySelectorAll('.wp-block-tabs-content-tabs-content');

document.addEventListener('DOMContentLoaded', function() {
    sections[0].classList.add('is-active')
})

// Funkcja do usuwania klasy is-active z sekcji
function removeActiveClasses() {
    sections.forEach(section => section.classList.remove('is-active'));
}
function removeActiveClassesBtns() {
    links.forEach(link => link.classList.remove('is-active'));
}

// Dodaj nasłuchiwanie na kliknięcia w linkach
links.forEach(link => {
    link.addEventListener('click', (event) => {
        event.preventDefault(); // Zapobiega domyślnemu zachowaniu (np. przewijaniu)

        removeActiveClassesBtns();
        link.classList.add('is-active')

        // Pobierz id z href linka
        const targetId = link.getAttribute('href').substring(1); // Usuwa #
        const targetSection = document.getElementById(targetId);

        if (targetSection) {
            // Usuń klasę is-active z wszystkich sekcji
            removeActiveClasses();

            // Dodaj klasę is-active do wybranej sekcji
            targetSection.classList.add('is-active');
        }
    });
});
/* eslint-enable no-console */
